import axios from 'axios';

export function listASXStockCodes() {
  return axios.get('/api/v1/stock_codes/NASDAQ', { cache: { ignoreCache: true } });
}

export function listAllStockCodes() {
  return axios.get('/api/v1/stock_codes/*', { cache: { ignoreCache: true } });
}
